<template>
  <div class="sp_createCase">
    <heade-title :title="title"
                 :showClose="showClose"
                 @closePage='closePage'></heade-title>

    <!-- 表单区域 -->
    <div class="sp_formCount">
      <el-form :model="createCaseForm"
               ref="createCaseForm"
               :rules="createCaseRules">
        <!-- 表单1 -->
        <div class="sp_stepFormOne">
          <div class="sp_stepsText"><span>1</span>
            <p>Hi, how can I help you?</p>
          </div>
          <div class="sp-form-content">
            <div class="sp_stepsLine"></div>
            <div class="sp-form">
              <p class="sp_stepsChild">1.1 What is your product?</p>
              <div class="sp_product">
                <el-form-item label="SN："
                              prop="sn"
                              class="sp_col">
                  <el-input size="medium"
                            type="text"
                            v-model="createCaseForm.sn"></el-input>
                </el-form-item>
                <div class="sp_col">
                  <div class="gateway-label"><span class="rule">*</span><span>Gateway ID/Key ID</span>
                    <a class="find"
                       href="https://community.sangfor.com/forum.php?mod=viewthread&tid=1057&highlight="
                       target="_blank">
                      (How to find):
                    </a>
                  </div>
                  <el-input class="gateway-input"
                            size="medium"
                            type="text"
                            :class="{'rule-input':showGatewayRule}"
                            @blur="gatewayHandler"
                            v-model="createCaseForm.gateWayId"></el-input>
                  <div v-show="showGatewayRule"
                       class="gateway-rule">{{gatewayRule}}</div>
                </div>
                <el-form-item label="Product："
                              prop="product"
                              class="sp_col">
                  <el-select size="small"
                             type="text"
                             v-model="createCaseForm.product"
                             placeholder="Please select product"
                             @change="changeProduct">
                    <el-option v-for="val in productList"
                               :key="val.id"
                               :label="val.name"
                               :value="val.id"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Version："
                              prop="version"
                              class="sp_col">
                  <el-select size="small"
                             type="text"
                             v-model="createCaseForm.version">
                    <el-option v-for="val in versionList"
                               :key="val.id"
                               :label="val.name"
                               :value="val.id"></el-option>
                  </el-select>
                </el-form-item>
              </div>
              <div class="sp_issue">
                <p class="sp_stepsChild">1.2 What is your issue?</p>
                <el-form-item label="Issue Title："
                              prop="issueTitle"
                              class="sp_col">
                  <el-input size="small"
                            type="text"
                            v-model="createCaseForm.issueTitle"
                            @blur="handleBlur"></el-input>
                </el-form-item>
                <el-form-item label="Issue Descriptions："
                              prop="issueDescriptions"
                              class="sp_col">
                  <el-input type="textarea"
                            :autosize="{ minRows: 6, maxRows: 12}"
                            v-model="createCaseForm.issueDescriptions"></el-input>
                </el-form-item>
                <el-form-item label="Upload Files："
                              class="sp_col upload-file">
                  <el-upload class="upload-demo"
                             ref="upload"
                             action=""
                             :http-request="uploadSectionFile"
                             :show-file-list="false"
                             multiple
                             :limit="3">
                    <el-button size="small">
                      <svg-icon icon-class="upload" />&nbsp;&nbsp;Upload
                    </el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                  </el-upload>
                  <div class="sp_fileList"
                       v-if="showFileList.length>0">
                    <div class="sp_fileListItem"
                         v-for="(val,index) in showFileList"
                         :key="index">
                      <div class="sp_fileName">
                        <p>
                          <svg-icon class="svg-icon"
                                    icon-class="fileicon" /><span :class="{isUploade:!val.show}"
                                class="sp_uploadfileName">{{val.name}}</span>
                        </p>
                        <i class="el-icon-close"
                           v-if="!val.show"
                           @click="removeFile(val.uid)"></i>
                      </div>
                      <el-progress :stroke-width="2"
                                   :percentage="val.percentage"
                                   :show-text="false"
                                   v-if="val.show"></el-progress>
                    </div>
                  </div>
                  <div class="upload-message">
                    The size does not exceed 10 MB.
                  </div>
                </el-form-item>
              </div>
            </div>

            <!-- 文章列表 -->

            <div ref="box"
                 class="box-card"
                 shadow="never">
              <div slot="header"
                   class="clearfix">Article</div>
              <div class="line"></div>
              <div ref="text"
                   class="text-content">
                <div class="sp_cardText"
                     v-for="(val,index) in articleList"
                     :key="val.articleId"
                     @click="gokonwledgeBase({val:val},'article')">
                  <h3 v-html="index+1+'.'+' '+val.title"></h3>
                  <p v-html="val.content"></p>
                </div>
              </div>
              <el-empty style="margin-top:50px;"
                        :image="nodataUrl"
                        :image-size="50"
                        description="No Data"
                        v-if="articleList && articleList.length==0"></el-empty>

              <div class="sp_moreArticle"
                   v-show="articleList && articleList.length>0">
                <el-button size="small"
                           @click="gokonwledgeBase({},'more')">More Article</el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 表单2 -->
        <div class="sp_stepFormTwo">
          <div class="sp_stepsText"><span>2</span>
            <p>How does this issue impact your business?</p>
          </div>
          <span v-show="showImpactRule"
                class="impact-rule">Please select case severity.</span>
          <div class="sp_impact-content">
            <div class="sp_stepsLine">
            </div>
            <div class="sp_impact"
                 :class="{'click-class':createCaseForm.impactLevel ==2 || createCaseForm.impactLevel ==1}">
              <div class="sp_impact-item"
                   v-for="val in impactList"
                   :key="val.id"
                   :ref="'impact'+val.id"
                   @click="checkImpact(val.id)">
                <h3 class="title">
                  <span>{{val.title}}</span>
                  <svg-icon class="svg-cion"
                            icon-class="hasselect" />
                </h3>
                <p class="content"
                   v-html="val.content"></p>
              </div>
            </div>

          </div>
          <div class="sp_impact-content">
            <div class="sp_stepsLine">
            </div>
            <div class="sp_impact_message">
              <div class="message-item"></div>
              <div class="message-item"></div>
              <div class="message-item">
                <div v-show="createCaseForm.impactLevel ==2">Please<a href="https://www.sangfor.com/support/technical-support"
                     target="_blank"> contact us</a> to make sure the issue can be fixed promptly.</div>
              </div>
              <div class="message-item">
                <div v-show="createCaseForm.impactLevel ==1">Please<a href="https://www.sangfor.com/support/technical-support"
                     target="_blank"> contact us</a> to make sure the issue can be fixed promptly.</div>
              </div>
            </div>
          </div>
        </div>

        <!-- 表单3 -->
        <div class="sp_stepFormThree">
          <div class="sp_stepsText"><span>3</span>
            <p>How can I contact you?</p>
          </div>
          <div class="sp_stepFormThree-form">
            <div class="sp_stepsLine"></div>
            <div class="stepFormThree-form">
              <div class="flex-box">
                <el-form-item label="Contact Person:"
                              prop="contact"
                              class="sp_col">
                  <el-input size="small"
                            v-model="createCaseForm.contact"
                            placeholder="Please input Contact Person:"></el-input>
                </el-form-item>
                <el-form-item label="Contact Way："
                              prop="contactWay"
                              class="sp_col">
                  <el-select size="small"
                             v-model="createCaseForm.contactWay"
                             placeholder="Please select contact way"
                             style="width:100%;">
                    <el-option label="All"
                               :value="0"></el-option>
                    <el-option label="Telephone"
                               :value="1"></el-option>
                    <el-option label="Email"
                               :value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item v-if="createCaseForm.contactWay==1||createCaseForm.contactWay==0"
                              label="Telephone："
                              prop="telephone"
                              class="sp_col sp_telSelect">
                  <el-input type="text"
                            v-model="createCaseForm.telephone"
                            placeholder="Please input tel."
                            size="small">
                    <el-select size="small"
                               filterable
                               no-match-text="No Data"
                               remote
                               :remote-method="remoteMethod"
                               @visible-change="areaCodeFocus"
                               v-model="createCaseForm.areaCode"
                               slot="prepend"
                               placeholder="Code">
                      <el-option :label="val.areaCode"
                                 :value="val.id"
                                 v-for="val in areaCodelist"
                                 :key="val.id">{{val.country+' '+val.areaCode}}</el-option>
                    </el-select>
                  </el-input>
                </el-form-item>
                <el-form-item v-if="createCaseForm.contactWay==2||createCaseForm.contactWay==0"
                              label="Email："
                              prop="email"
                              class="sp_col">
                  <el-input size="small"
                            v-model="createCaseForm.email"
                            placeholder="Please input contact"></el-input>
                </el-form-item>
              </div>
              <p class="sp_ccEmailTitle">CC Email</p>
              <div class="sp_ccEmailItem"
                   v-for="(val, index) in createCaseForm.ccEmail"
                   :key="index">
                <el-form-item :prop="'ccEmail.' + index"
                              :rules="ccEmailRules.ccEmail"
                              class="sp_ccEmailInput">
                  <el-input v-model="createCaseForm.ccEmail[index]"
                            size="small">
                    <svg-icon slot="suffix"
                              icon-class="delete"
                              class="deleteemail"
                              @click.native="delectCcEmail(index)"
                              style="cursor: pointer" />
                  </el-input>
                </el-form-item>
                <!-- <svg-icon icon-class="addinput"
                          v-if="index == 0"
                          class="addccemail"
                          @click.native="AddCcEmail" /> -->
              </div>
              <el-button plain
                         class="add-btn"
                         @click.native="AddCcEmail">
                <svg-icon icon-class="add"></svg-icon>&nbsp;&nbsp;Add
              </el-button>
            </div>
          </div>

        </div>

        <!-- 表单4 -->
        <div class="sp_stepFormFour">

          <div class="sp_stepsText"><span>4</span>
            <p>When do you prefer to contact you? (Optional)</p>
          </div>
          <!-- <span class="sp_stepsLine"></span> -->
          <div class="sp_stepFormFour-content">
            <div class="sp_stepsLine-four"></div>
            <div class="flex-box">
              <el-form-item label="Time Zone"
                            class="sp_col">
                <el-select filterable
                           v-model="createCaseForm.timeZone"
                           clearable
                           placeholder="Please select time zone"
                           size="small">
                  <el-option :label="val.timeZone"
                             :value="val.id"
                             v-for="val in timeZoneList"
                             :key="val.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="Date & Time"
                            class="sp_col"
                            size="small">
                <el-date-picker :picker-options="pickerOptions"
                                size="medium"
                                v-model="createCaseForm.timeStamp"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="Please select date & time">
                </el-date-picker>
              </el-form-item>
            </div>
          </div>
        </div>
        <div class="bottom-line"></div>
        <el-row class="sp_button">
          <el-col>

            <el-button :loading="saveLoading"
                       type="primary"
                       size="medium"
                       @click="submitCase('createCaseForm')">Submit</el-button>
            <el-button plain
                       size="medium"
                       @click="closePage">Cancel</el-button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </div>
</template>

<script>
import headeTitle from '../../components/headeTitle.vue'
import {
  saveCaseApi,
  getVersionApi,
  uploadFilesApi,
  getKbArticlesApi,
} from '@/api/case.js'
export default {
  name: 'createCase',
  components: { headeTitle },
  data() {
    var checkSN = (rule, value, callback) => {
      const snLength = [8, 10, 11, 16, 40]
      if (!value) {
        return callback()
      }
      setTimeout(() => {
        if (snLength.includes(value.length)) {
          callback()
        } else {
          callback(new Error('Please input the correct SN.'))
        }
      }, 200)
    }
    var checkgateWayId = (rule, value, callback) => {
      const snLength = [8, 10, 11, 16, 40]
      if (!value) {
        return callback(new Error('Please input Gateway ID/ Key ID.'))
      }
      setTimeout(() => {
        if (snLength.includes(value.length)) {
          callback()
        } else {
          callback(new Error('Please input the correct Gateway ID/ Key ID.'))
        }
      }, 200)
    }
    var checkIssueTitle = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input the issue title.'))
      } else {
        if (value.length > 255) {
          callback(new Error('Issue Description cannot exceed 255 characters.'))
        } else {
          callback()
        }
      }
    }
    var checkIssueDescriptions = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('Please input the issue description.'))
      } else {
        if (value.length > 4000) {
          callback(
            new Error('Issue Description cannot exceed 4000 characters.')
          )
        } else {
          callback()
        }
      }
    }
    var checkTelephone = (rule, value, callback) => {
      if (value && this.createCaseForm.areaCode !== '') {
        if (value.length > 255) {
          return callback(new Error('Cannot exceed over 255 characters.'))
        } else {
          return callback()
        }
      } else {
        return callback(new Error('Please input region code or tel.'))
      }
    }
    var checkEmail = (rule, value, callback) => {
      const eMailReg =
        /^([a-zA-Z0-9_+-.])+@([a-zA-Z0-9_+-])+((\.[a-zA-Z0-9_-]{2,20}){1,4})$/
      if (!value) {
        return callback(new Error('Please input email.'))
      }
      setTimeout(() => {
        if (eMailReg.test(value)) {
          callback()
        } else {
          callback(new Error('Please input the correct email format.'))
        }
      }, 200)
    }
    var checkCcEmail = (rule, value, callback) => {
      const eMailReg =
        /^([a-zA-Z0-9_+-.])+@([a-zA-Z0-9_+-])+((\.[a-zA-Z0-9_-]{2,20}){1,4})$/
      if (!value) {
        return callback()
      }
      setTimeout(() => {
        if (eMailReg.test(value)) {
          callback()
        } else {
          callback(new Error(this.$t('Please input the correct email format.')))
        }
      }, 200)
    }
    return {
      title: 'Create Case',
      showClose: true,
      gatewayRule: 'Please input Gateway ID/ Key ID.',
      showGatewayRule: false,
      showImpactRule: false,
      createCaseForm: {
        sn: '',
        gateWayId: '',
        product: '',
        version: '',
        issueTitle: '',
        issueDescriptions: '',
        contact: '',
        contactWay: 0,
        impactLevel: 0,
        telephone: '',
        areaCode: '',
        email: '',
        ccEmail: [''],
        timeZone: '',
        timeStamp: '',
        fileList: [],
        customer: '',
      },
      createCaseRules: {
        sn: [{ required: false, validator: checkSN, trigger: 'blur' }],
        gateWayId: [
          { required: true, validator: checkgateWayId, trigger: 'blur' },
        ],
        product: [
          {
            required: true,
            message: 'Please select a product.',
            trigger: 'change',
          },
        ],
        version: [
          {
            required: true,
            message: 'Please select a version.',
            trigger: 'change',
          },
        ],
        issueTitle: [
          { required: true, validator: checkIssueTitle, trigger: 'blur' },
        ],
        issueDescriptions: [
          {
            required: true,
            validator: checkIssueDescriptions,
            trigger: 'blur',
          },
        ],
        contact: [
          { required: true, message: 'Please input contact.', trigger: 'blur' },
        ],
        contactWay: [
          {
            required: true,
            message: 'Please input select contact way.',
            trigger: 'change',
          },
        ],
        telephone: [
          { required: true, validator: checkTelephone, trigger: 'blur' },
        ],
        email: [{ required: true, validator: checkEmail, trigger: 'blur' }],
      },
      ccEmailRules: {
        ccEmail: [
          { required: true, validator: checkCcEmail, trigger: ['blur'] },
        ],
      },
      articleList: [],
      impactList: [
        {
          id: 4,
          title: 'Low Impact',
          content:
            '1.The issues for certain features/capabilities do not impact business operations and have no loss of functionality.<br />2.Documentation Issues.<br />3.General "how-to" questions.',
          icon: 'low',
        },
        {
          id: 3,
          title: 'Medium Impact',
          content:
            '1.Performance of the network or application is impaired with limited impact on business operations and an acceptable workaround or solution exists.<br />2.The issue with non-critical features or functionality.<br />3.Successful workaround in place for a severity 2 issue. ',
          icon: 'medium',
        },
        {
          id: 2,
          title: 'High Impact',
          content:
            '1.Network or application is operational but highly degraded performance to the point of major impact on usage.<br />2.Continuous or frequent instabilities affecting customer business or network operations.<br />3.Inability to deploy a feature, function or capability.<br />4.Successful workaround in place for a severity 1 issue.',
          icon: 'high',
        },
        {
          id: 1,
          title: 'Serious Impact',
          content:
            '1.Network or application outage, "down or unavailable".<br />2.Impaired functionality, critically impacting customer business.<br /> 2.Impaired functionality, critically impacting customer business.',
          icon: 'serious',
        },
      ],

      areaCodelist: [],
      pickerOptions: {
        disabledDate(time) {
          let seven = 8 * 24 * 60 * 60 * 1000
          let sevenDays = Date.now() + seven - 8.64e7
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > sevenDays
          )
          // return time.getTime() < Date.now() - 8.64e7;
        },
      },
      saveLoading: false,
      productList: [],
      timeZoneList: [],
      versionList: [],
      showFileList: [],
      articleLoading: false,
      currentImpactId: '',
      nodataUrl: require('../../assets/img/nodata.png'),
    }
  },
  watch: {
    '$store.state.user.loadCasePage': {
      handler(val) {
        if (val) {
          this.$emit('createCaseChildMsg', { close: false })
        }
      },
      immediate: true,
    },
  },
  methods: {
    gatewayHandler() {
      const snLength = [8, 10, 11, 16, 40]
      const value = this.createCaseForm.gateWayId
      if (!value) {
        this.showGatewayRule = true
        this.gatewayRule = 'Please input Gateway ID/ Key ID.'
      }
      setTimeout(() => {
        if (snLength.includes(value.length)) {
          this.showGatewayRule = false
          return
        } else {
          this.showGatewayRule = true
          this.gatewayRule = 'Please input the correct Gateway ID/ Key ID.'
        }
      }, 200)
    },

    closePage() {
      this.$emit('createCaseChildMsg', { isSave: false, close: false })
    },

    //上传文件
    uploadSectionFile(params) {
      let fileSize = params.file.size / 1024 / 1024 < 10
      if (!fileSize) {
        this.$message({
          type: 'warning',
          message: 'The file cannot be larger than 10M.',
          duration: 4000,
        })
      } else {
        let supportedFileTypes = [
          'cxg',
          'jpg',
          'gif',
          'bmp',
          'tiff',
          'png',
          'jpeg',
          'rm',
          'mvb',
          'avi',
          'asf',
          'wmv',
          'mov',
          'mpg',
          'mpeg',
          'vob',
          'fiv',
          'mp4',
          'zip',
          'rar',
          'gz',
          'bz2',
          'tgz',
          'cab',
          '7z',
          'bz',
          'Z',
          'doc',
          'docx',
          'xls',
          'xlsx',
          'pdf',
          'txt',
        ]
        let fileType = params.file.name.split('.')
        let result = supportedFileTypes.includes(fileType[fileType.length - 1])
        if (!result) {
          this.$message({
            type: 'warning',
            message:
              'The files included the unsupported format, please select again.',
          })
          return false
        }
        this.showFileList.push({
          name: params.file.name,
          percentage: 0,
          uid: params.file.uid,
          size: params.file.size,
          url: '',
          show: true,
        })
        console.log(params)

        for (let i = 0; i < this.showFileList.length; i++) {
          const config = {
            onUploadProgress: function (progressEvent) {
              this.showFileList[i].percentage = Number(
                ((progressEvent.loaded / progressEvent.total) * 90).toFixed(2)
              )
            }.bind(this),
          }

          if (this.showFileList[i].uid == params.file.uid) {
            let form = new FormData()
            form.append('file', params.file)
            uploadFilesApi(form, config)
              .then((res) => {
                console.log(res)
                this.showFileList[i].percentage = 100
                this.showFileList[i].url = res.url
                this.showFileList[i].groupUrl = res.groupUrl
                setTimeout(() => {
                  this.showFileList[i].show = false
                  this.$refs.upload.clearFiles()
                }, 200)
              })
              .catch(() => {
                this.showFileList.splice(i, 1)
              })
          }
        }
      }
    },

    //移除上传文件
    removeFile(id) {
      this.showFileList.forEach((val, index) => {
        if (val.uid == id) {
          this.showFileList.splice(index, 1)
        }
      })
    },

    //选择问题严重等级
    checkImpact(id) {
      this.showImpactRule = false
      let impactArr = [1, 2, 3, 4]
      impactArr.splice(id - 1, 1)
      this.$refs[`impact${id}`][0].style.background = '#F2F8FF'
      this.$refs[`impact${id}`][0].style.borderColor = '#2684FF'
      this.$refs[`impact${id}`][0].childNodes[0].childNodes[1].style.display =
        'inline-block'
      this.createCaseForm.impactLevel = id
      for (var i = 0; i < impactArr.length; i++) {
        this.$refs[`impact${impactArr[i]}`][0].style.background = '#fff'
        this.$refs[`impact${impactArr[i]}`][0].style.borderColor = '#DCDFE6'
        this.$refs[
          `impact${impactArr[i]}`
        ][0].childNodes[0].childNodes[1].style.display = 'none'
      }
    },

    //电话区号搜索
    remoteMethod(qurey) {
      this.areaCodelist = this.$ls.get('AreaCode')
      this.areaCodelist = this.areaCodelist.filter((val) => {
        if (
          (val.country + ' ' + val.areaCode)
            .toLowerCase()
            .replace(/\s/g, '')
            .indexOf(qurey.toLowerCase().replace(/\s/g, '')) != -1
        ) {
          return true
        }
        return false
      })
    },
    areaCodeFocus(qurey) {
      setTimeout(() => {
        if (!qurey) {
          this.areaCodelist = this.$ls.get('AreaCode')
        }
      }, 200)
    },

    //获取版本号
    changeProduct(data) {
      let params = {
        id: data + '',
      }
      this.createCaseForm.version = ''
      this.getKbArticles()
      getVersionApi(params).then((res) => {
        this.versionList = res.rows.filter((val) => {
          if (
            val.name.toLowerCase() == 'custom version' ||
            val.name.toLowerCase() == 'unknown version'
          ) {
            return false
          }
          return true
        })
      })
    },

    //删除ccEmail框
    delectCcEmail(index) {
      this.createCaseForm.ccEmail.splice(index, 1)
    },

    //新增ccEmail框
    AddCcEmail() {
      this.createCaseForm.ccEmail.push('')
    },

    //保存工单
    submitCase(createCaseForm) {
      if (!this.createCaseForm.gateWayId) {
        this.showGatewayRule = true
        this.gatewayRule = 'Please input Gateway ID/ Key ID.'
      } else {
        this.showGatewayRule = false
      }
      const isSelectImpact =
        this.createCaseForm.impactLevel === 0 ? false : true
      if (!isSelectImpact) {
        this.showImpactRule = true
      } else {
        this.showImpactRule = false
      }
      this.$refs[createCaseForm].validate((valid, error) => {
        if (valid && !this.showGatewayRule && !this.showImpactRule) {
          this.saveLoading = true
          let params = JSON.parse(JSON.stringify(this.createCaseForm))
          params.fileList = this.showFileList
          params.customer = this.$store.getters.userInfo.corpsName
          if (params.contactWay == 1) {
            delete params.email
          } else if (params.contactWay == 2) {
            delete params.telephone
          }
          // this.$confirm('Confirm to submit?', {
          //   confirmButtonText: 'Confirm',
          //   cancelButtonText: 'Cancel',
          //   type: 'warning'
          // }).then(() => {
          saveCaseApi(params)
            .then((res) => {
              console.log(res)
              this.$message({
                type: 'success',
                message: 'Save successfully',
              })
              this.saveLoading = false
              this.$emit('createCaseChildMsg', { isSave: true, close: false })
            })
            .catch(() => {
              this.saveLoading = false
            })
          // })
          //   .catch(() => {
          //     this.saveLoading = false;
          //   });
        } else {
          let errArr = []
          for (let key in error) {
            // errMsg += err[key][0].field + "，";
            // 提示信息： err[key][0].field
            errArr.push(key)
          }
          this.$el.querySelector('#' + errArr[0]).scrollIntoView({
            behavior: 'smooth',
            block: 'start',
          })
        }
      })
    },

    //跳转知识库
    gokonwledgeBase(val, type) {
      let url = ''
      switch (process.env.NODE_ENV) {
        case 'development':
          url = 'http://localhost:8081'
          break
        case 'test':
          url = 'http://200.200.4.153:8080'
          break
        case 'uat':
          url = 'http://200.200.4.187:8080'
          break
        case 'production':
          url = 'http://knowledgebase.sangfor.com/'
          break

        default:
          break
      }

      if (type == 'more') {
        window.open(url + '/searchDetail')
      } else {
        let token = this.$ls.get('token')
        let data = {
          articleType: val.articleType,
          articleId: val.articleId,
          keyword: '',
        }
        window.open(url + '/detailPage?&articleData=' + JSON.stringify(data))
      }
    },

    //工单标题失焦查询kb文章
    handleBlur() {
      this.getKbArticles()
    },

    //获取kb文章列表
    getKbArticles() {
      let params = {
        keyWord: this.createCaseForm.issueTitle,
        moduleId: '',
        pageNumber: 1,
        pageSize: 5,
        sortType: '',
        menuId: this.createCaseForm.product,
      }
      params.moduleId = params.menuId == '' ? '76' : ''
      params.menuId = params.menuId + ''
      this.articleLoading = true
      getKbArticlesApi(params)
        .then((res) => {
          this.articleList = res.rows.rows
          this.articleLoading = false
        })
        .catch(() => {
          this.articleList = []
          this.articleLoading = false
        })
    },
  },

  created() {
    this.areaCodelist = this.$ls.get('AreaCode')
    this.productList = this.$ls.get('product')
    this.timeZoneList = this.$ls.get('timeZone')
    let userInfo = this.$store.getters.userInfo
    console.log(userInfo)
    this.createCaseForm.telephone = userInfo.phone
    this.createCaseForm.areaCode = userInfo.areaCode
    this.createCaseForm.email = userInfo.email
    this.createCaseForm.contact = userInfo.firstName + ' ' + userInfo.lastName
  },
}
</script>

<style scoped lang="scss">
@media screen and (max-width: 1366px) {
  .sp_createCase {
    min-width: 1110px;
    .sp_formCount {
      width: calc(100% - 16px) !important;
    }
  }
}
.sp_createCase {
  width: 100%;
  .sp_formCount {
    width: 100%;
    background: #fff;
    padding: 16px;

    .sp_stepFormOne {
      width: 100%;
      padding: 16px 20px 0;
      .sp-form-content {
        display: flex;
        justify-content: space-between;
        .sp-form {
          padding: 12px 16px 0 8px;
          width: 50%;
          flex-wrap: nowrap;
          .sp_stepsChild {
            font-size: 14px;
            color: #333940;
            margin: 0 24px 8px;
            line-height: 20px;
            font-weight: 500;
          }
          .sp_product {
            display: flex;
            flex-wrap: wrap;
            @media screen and (max-width: 1366px) {
              .sp_col {
                padding-right: 0 !important;
              }
            }
            .sp_col {
              box-sizing: border-box;
              width: 50%;
              padding: 0 24px 0px;
              margin-bottom: 16px;
              @media screen and (max-width: 1366px) {
                /deep/.el-form-item__content {
                  width: 222px;
                }
              }
              /deep/.el-form-item__content {
                line-height: 32px;
                min-width: 222px;
              }
              /deep/.el-form-item__label {
                color: #545c66;
                height: 20px;
                line-height: 20px;
                margin-bottom: 4px;
                font-size: 14px;
              }
            }
            .gateway-label {
              height: 20px;
              line-height: 20px;
              color: #545c66;
              margin-bottom: 4px;
              font-size: 14px;
              white-space: nowrap;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .rule {
                color: #f56c6c;
                margin-left: -10px;
                margin-right: 4px;
              }
              .find {
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                font-size: 12px;
              }
            }
            .gateway-input {
              width: 100%;
              min-width: 222px;
            }
            .rule-input {
              /deep/.el-input__inner {
                border: 1px solid #f56c6c !important;
              }
            }
            .gateway-rule {
              position: absolute;
              color: #f56c6c;
              font-size: 12px;
              height: 16px;
              line-height: 16px;
              padding-top: 4px;
            }
          }
          .sp_issue {
            margin-top: 12px;
            margin-bottom: 24px;
            @media screen and (max-width: 1366px) {
              /deep/.el-form-item__content {
                width: 472px;
              }
            }
            /deep/.el-form-item__content {
              min-width: 472px;
            }
            .upload-file {
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .sp_fileList {
                .sp_fileListItem {
                  .sp_fileName {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;
                    font-size: 14px;
                    .svg-icon {
                      margin-right: 6px;
                    }
                    .sp_uploadfileName {
                      color: #006bf5;
                    }
                  }
                }
              }
              .upload-message {
                height: 20px;
                line-height: 20px;
                margin-top: 5px;
                font-size: 14px;
                color: #a1a8b3;
              }
            }
            .sp_col {
              box-sizing: border-box;
              padding: 0 24px 0px;
              margin-bottom: 16px;
              /deep/.el-form-item__content {
                line-height: 32px;
              }
              /deep/.el-form-item__label {
                color: #545c66;
                height: 20px;
                line-height: 20px;
                margin-bottom: 4px;
                font-size: 14px;
              }
            }
          }
        }
        .box-card {
          width: 50%;
          position: relative;
          margin-top: 12px;
          padding: 0 16px;
          min-height: 320px;
          height: 50%;
          background-color: #fafbfc;
          border: 1px solid #e1e6ed;
          border-radius: 2px;
          .clearfix {
            font-size: 16px;
            color: #333940;
            height: 40px;
            padding: 9px 0;
          }
          .line {
            border-bottom: 1px solid #e9edf2;
          }
          .text-content {
            margin-top: 12px;
            .sp_cardText {
              width: 100%;
              padding: 4px 8px;
              &:hover {
                background: #f5f6f8;
                h3 {
                  color: #007aff;
                }
              }
              h3 {
                font-size: 14px;
                color: #13161a;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                cursor: pointer;
                height: 20px;
                line-height: 20px;
              }
              p {
                font-size: 14px;
                color: #333940;
                padding-left: 20px;
                line-height: 20px;
                margin-top: 4px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
                cursor: pointer;
              }
            }
          }
          .sp_moreArticle {
            // position: absolute;
            // bottom: 8px;
            margin: 16px 0;
            width: 100%;
            text-align: center;
            // padding: 8px 0;
            // height: 48px;
            span {
              display: inline-block;
              padding: 12px 14px;
              height: 32px;
              line-height: 32px;
              border: 1px solid #cccfd9;
              border-radius: 2px;
              color: #333940;
              cursor: pointer;
              font-size: 14px;
              &:hover {
                color: #007aff;
                border-color: #007aff;
              }
            }
          }
        }
      }
    }
    .sp_stepFormTwo {
      width: 100%;
      padding: 0 20px;
      position: relative;
      .impact-rule {
        position: absolute;
        margin-left: 46px;
        top: 22px;
        color: #f56c6c;
        font-size: 12px;
      }
      .sp_impact-content {
        display: flex;
        justify-content: flex-start;
        .click-class {
          padding-bottom: 8px !important;
        }
        .sp_impact {
          padding: 12px 28px 24px;
          display: flex;
          .sp_impact-item {
            width: 24%;
            margin: 0 4px;
            padding: 12px 17px;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            cursor: pointer;
            .title {
              font-size: 16px;
              font-weight: 500;
              color: #2b2b2b;
              height: 22px;
              line-height: 22px;
              display: flex;
              justify-content: space-between;
              .svg-cion {
                color: #2684ff;
                display: none;
              }
            }
            .content {
              margin-top: 8px;
              font-size: 14px;
              color: #636878;
              line-height: 20px;
            }
          }
          .sp_impact-item:active {
            border: 1px solid #2684ff;
            background-color: #f2f8ff;
          }
        }
        .sp_impact_message {
          padding: 0 28px;
          width: 100%;
          display: flex;
          .message-item {
            width: 24%;
            margin: 0 4px;
            padding: 0 17px;
            font-size: 14px;
          }
        }
      }
      .sp_message-content {
        display: flex;
        justify-content: flex-start;
      }
      // .initStyle {
      //   background: rgba(0, 178, 122, 0.1);
      //   border-color: #00b27a;
      // }
    }
    .sp_stepFormThree {
      width: 100%;
      padding: 0 20px;
      .sp_stepFormThree-form {
        width: 100%;
        display: flex;
        .stepFormThree-form {
          padding: 12px 16px 24px 8px;
          width: 100%;
          position: relative;
          .flex-box {
            display: flex;
            flex-wrap: wrap;
            .sp_col {
              box-sizing: border-box;
              width: 25%;
              padding: 0 24px 0px;
              margin-bottom: 16px;
              /deep/.el-form-item__content {
                line-height: 32px;
                min-width: 212px;
              }
              /deep/.el-form-item__label {
                color: #545c66;
                height: 20px;
                line-height: 20px;
                margin-bottom: 4px;
                font-size: 14px;
              }
            }
          }
          .sp_ccEmailTitle {
            margin-left: 32px;
            margin-bottom: 4px;
            font-size: 14px;
            color: #545c66;
            box-sizing: border-box;
            width: 25%;
          }
          .sp_ccEmailItem {
            width: 25%;
            box-sizing: border-box;
            .el-form-item {
              padding: 0 24px 0;
            }
            .addccemail {
              position: absolute;
              bottom: 33px;
              margin-left: 10px;
              left: 25%;
              width: 14px;
              height: 14px;
              color: #2684ff;
            }
            .sp_ccEmailInput {
              margin-bottom: 16px;
              /deep/.el-input__suffix {
                right: -24px;
              }
              /deep/.el-form-item__content {
                min-width: 212px;
                line-height: 32px;
              }
              .deleteemail {
                color: #77808c;
              }
              .deleteemail:hover {
                color: #2684ff;
              }
              .deleteemail:active {
                color: #2684ff;
              }
            }
          }
          .add-btn {
            margin-left: 24px;
            margin-top: 1px;
          }
        }
      }
    }
    .sp_stepFormFour {
      padding: 0 20px;
      .sp_stepFormFour-content {
        display: flex;
        .sp_stepsLine-four {
          margin-left: 13px;
        }
        .flex-box {
          padding: 12px 16px 0 8px;
          display: flex;
          width: 100%;
          .sp_col {
            box-sizing: border-box;
            width: 25%;
            padding: 0 24px 0px;
            margin-bottom: 16px;
            /deep/.el-form-item__content {
              line-height: 32px;
              min-width: 212px;
            }
            /deep/.el-form-item__label {
              color: #545c66;
              height: 20px;
              line-height: 20px;
              margin-bottom: 4px;
              font-size: 14px;
            }
          }
        }
      }
      /deep/ .el-select {
        width: 100%;
      }
    }
    .bottom-line {
      margin-top: 4px;
      border-bottom: 1px solid #e9edf2;
    }
    .sp_button {
      // margin-top: 10px;
      padding: 12px 8px;
      .el-button {
        height: 36px;
      }
    }
  }
}
.sp_stepsText {
  width: 100%;
  display: flex;
  height: 28px;
  align-items: center;
  span {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    text-align: center;
    line-height: 28px;
    color: #fff;
    background: #007aff;
    font-weight: 600;
    z-index: 1;
  }
  p {
    height: 22px;
    line-height: 22px;
    font-size: 16px;
    font-weight: 600;
    margin-left: 8px;
  }
}
.sp_stepsLine {
  border-left: 1px dashed #d3d9e0;
  margin-left: 13px;
}
/deep/.el-input-group__prepend {
  width: 30%;
  background: #fff;
}
/deep/.el-select {
  .el-select__caret:first-child::before {
    content: '\e6e1';
  }
  .is-focus {
    .el-select__caret:first-child {
      transform: rotateZ(0deg);
    }
  }
}
.el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
/deep/.el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  margin-left: -10px !important;
}
</style>